var React = require('react');

function SearchLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.98 4.98a17 17 0 1124.04 24.04A17 17 0 014.98 4.98zM17 2a15 15 0 100 30 15 15 0 000-30z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.605 27.605a1 1 0 011.414 0l18.688 18.688a1 1 0 01-1.414 1.414L27.605 29.02a1 1 0 010-1.414z","key":1})]);
}

SearchLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SearchLight;

SearchLight.default = SearchLight;
